import React from 'react'

import { AttentionOutlined, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

// Always rendered so its height is reserved; the inputs above never shift when
// the error toggles on an invalid code.
function ErrorMessage({ hasError, locale = 'en' }) {
  return (
    <div className="auth-modal__code-error" role="alert">
      {hasError && (
        <>
          <Icon color="warning" notSpaced size="small" svgComponent={AttentionOutlined} />
          <span className="cgt-caption-semibold auth-modal__code-error-text">
            {i18n.t('auth_modal.code.error', { ns: 'rails', lng: locale })}
          </span>
        </>
      )}
    </div>
  )
}

ErrorMessage.propTypes = {
  hasError: bool.isRequired,
  locale: string,
}

export default ErrorMessage
